import type { ContentBlock } from '@lingoda/monolith-graphql';
import { Alert, Box, DangerousHtml, Typography, styled } from '@lingoda/ui';
import { ContentBlockIcon } from '@lingoda/content-blocks';
import Table from './Table';

export interface Props {
    contentBlock: ContentBlock;
}

const BannerBox = styled(Box)(({ theme }) => ({
    ' ul': {
        paddingInlineStart: theme.spacing(3),
    },
}));

const InformationBanner = ({ contentBlock }: Props) => (
    <Alert
        severity="promotion"
        title={contentBlock.label || ''}
        icon={contentBlock.icon ? <ContentBlockIcon icon={contentBlock.icon} /> : false}
    >
        <BannerBox>
            <Typography>
                <DangerousHtml>{contentBlock.text}</DangerousHtml>
            </Typography>
            {contentBlock.table && (
                <Box mt={1} width="fit-content">
                    <Table data={contentBlock.table} />
                </Box>
            )}
        </BannerBox>
    </Alert>
);

export default InformationBanner;
